module.exports = __webpack_public_path__ + "static/img/labour-11.1f69ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-11.png
// module id = WOyA
// module chunks = 1